import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { usePopper } from 'react-popper';
export var PopoutPlacements = {
  AUTO: 'auto',
  AUTO_START: 'auto-start',
  AUTO_END: 'auto-end',
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
};
/**
 * Create the attributes necessary to render a tooltip/popper
 *
 * The first argument is an object of generic properties that are relevant to all popouts.
 *
 * The second argument is an object passed directly to the library responsible for handling
 * the tooltip/popout behavior, in this case Popper.js.
 */

export default function usePopout() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? PopoutPlacements.BOTTOM : _ref$placement,
      _ref$xOffset = _ref.xOffset,
      xOffset = _ref$xOffset === void 0 ? 0 : _ref$xOffset,
      _ref$yOffset = _ref.yOffset,
      yOffset = _ref$yOffset === void 0 ? 0 : _ref$yOffset;

  var popperOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _popperOptions$modifi = popperOptions.modifiers,
      modifiers = _popperOptions$modifi === void 0 ? [] : _popperOptions$modifi,
      popperOptionsWithoutModifiers = popperOptions.popperOptionsWithoutModifiers;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      referenceElement = _useState2[0],
      setReferenceElement = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      popperElement = _useState4[0],
      setPopperElement = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      arrowElement = _useState6[0],
      setArrowElement = _useState6[1];

  var _usePopper = usePopper(referenceElement, popperElement, _objectSpread({
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: [xOffset, yOffset]
      }
    }, ...modifiers],
    placement
  }, popperOptionsWithoutModifiers)),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  return {
    arrowRef: setArrowElement,
    anchorRef: setReferenceElement,
    popoutRef: setPopperElement,
    attributes,
    styles
  };
}